// Icon mapping for cloth types
// Using emoji characters directly in the code

export const CLOTH_ICONS: Record<string, string> = {
  // Male & Female
  'tshirt': '\u{1F455}',  // ??
  'shirt': '\u{1F454}',   // ??
  'pants': '\u{1F456}',   // ??
  'jeans': '\u{1F456}',   // ??
  'shorts': '\u{1FA73}',  // ??
  'jacket': '\u{1F9E5}',  // ??
  'blazer': '\u{1F3BD}',  // ??
  
  // Female specific
  'top': '\u{1F45A}',     // ??
  'crop-top': '\u{1F3BD}', // ??
  'blouse': '\u{1F454}',  // ??
  'dress': '\u{1F457}',   // ??
  'skirt': '\u{1FA71}',   // ??
  'leggings': '\u{1F9D8}', // ??
  'kurti': '\u{1F97B}',   // ??
  'saree': '\u{1F97B}',   // ??
  'lehenga': '\u{1F457}', // ??
  'salwar-kameez': '\u{1F97B}', // ??
  'jumpsuit': '\u{1FA71}', // ??
  'cardigan': '\u{1F9F6}', // ??
  
  // Male specific
  'kurta': '\u{1F97B}',   // ??
  'kurta-pajama': '\u{1F97B}', // ??
  'sherwani': '\u{1F935}', // ??
  'suit': '\u{1F935}',    // ??
  'hoodie': '\u{1F9E5}',  // ??
  'sweater': '\u{1F9F6}', // ??
};

// Fallback icon if cloth type not found
export const FALLBACK_CLOTH_ICON = '\u{1F454}'; // ??

// Helper function to get icon for a cloth type
export const getClothIcon = (clothTypeId: string): string => {
  return CLOTH_ICONS[clothTypeId] || FALLBACK_CLOTH_ICON;
};

// Gender icons
export const GENDER_ICONS = {
  male: '\u{1F468}',    // ??
  female: '\u{1F469}',  // ??
};

